<template>
  <auth-layout class="not-found-page">
    <div class="centered">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>403</h1>
      <p>No estas autorizado en el sistema</p>

      <button @click="logout" class="btn btn-danger">Cerrar Session</button>
    </div>
  </auth-layout>
</template>

<script>

  import AuthLayout from 'src/views/Layout/AuthLayout.vue'
  import { Loading } from "element-ui"
  import router from '../routes'; 

  export default {
    components: {
      AuthLayout
    },
    mounted(){
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        })
        this.loadingInstance.close()
    },
    methods:{
        logout()
        {
            router.push({path : 'logout'})
        }

    },
    data(){
        return {
            loadingInstance: null
        }
      }
  }
</script>
<style lang="scss">
  .not-found-page {
    .full-page > .content,
    .centered {
      min-height: calc(100vh - 160px);
    }
    .not-found-icon {
      margin-right: 10px;
    }
    .centered {
      h1, i {
        font-size: 50px;
      }
      p {
        font-size: 20px;
      }
      display: flex;
      padding-bottom: 150px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: white;
    }
  }

</style>
